import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Chip,
  Divider,
} from "@mui/material";
import { Icon } from "../../icons";
import { COLORS, TYPOGRAPHY } from "../../constants/color";

const statusStyles = {
  Active: { bgcolor: "#8CD47E", color: "#fff", borderColor: "#8CD47E" },
  APPROVED: { bgcolor: "#8CD47E", color: "#fff", borderColor: "#8CD47E" },
  Pending: { bgcolor: "#F8D66D", color: "#fff", borderColor: "#F8D66D" },
  PENDING: { bgcolor: "#F8D66D", color: "#fff", borderColor: "#F8D66D" },
  Rejected: { bgcolor: "#FF6961", color: "#fff", borderColor: "#FF6961" },
  REJECTED: { bgcolor: "#FF6961", color: "#fff", borderColor: "#FF6961" },
};

const getStatusText = (status) => {
  switch (status) {
    case "APPROVED":
      return "Active";
    case "PENDING":
      return "Pending";
    case "REJECTED":
      return "Rejected";
    default:
      return status || "Pending";
  }
};

const ClientDetailsPopup = ({ open, onClose, client }) => {
  if (!open || !client) return null;

  const displayStatus = getStatusText(client.status);

  return (
    <>
      {/* Overlay */}
      <Box
        onClick={onClose}
        sx={{
          position: "fixed",
          inset: 0,
          bgcolor: "rgba(0,0,0,0.5)",
          zIndex: 1400,
        }}
      />

      {/* Modal */}
      <Box
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "#fff",
          borderRadius: 2,
          p: 3,
          zIndex: 1401,
          boxShadow: "0px 12px 30px rgba(0,0,0,0.2)",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Typography sx={{ ...TYPOGRAPHY.H3, color: COLORS.PRIMARY }}>
            Client Details
          </Typography>

          <IconButton onClick={onClose} sx={{ p: 1 }}>
            <Icon name="close" color={COLORS.ERROR} />
          </IconButton>
        </Box>

        <Divider sx={{ mb: 3 }} />

        {/* Client Info */}
        <Box sx={{ mb: 2 }}>
          {/* Name + Status */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
            <Icon name="profile" color={COLORS.PRIMARY} size={24} />
            <Typography sx={{ ...TYPOGRAPHY.H3, color: COLORS.TEXT }}>
              {client.name}
            </Typography>

            <Chip
              label={displayStatus}
              size="small"
              sx={{ ...statusStyles[client.status], height: 20, ...TYPOGRAPHY.BODY_SMALL, ml: 1 }}
            />
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pl: "32px" }}>
            {/* Email */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Icon name="at" size={16} color={COLORS.SECONDARY} />
              <Typography sx={{ ...TYPOGRAPHY.BODY_STANDARD, color: COLORS.TEXT }}>
                <strong>Email:</strong> {client.email || "-"}
              </Typography>
            </Box>

            {/* Phone */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Icon name="phoneDone" size={16} color={COLORS.SECONDARY} />
              <Typography sx={{ ...TYPOGRAPHY.BODY_STANDARD, color: COLORS.TEXT }}>
                <strong>Phone:</strong> {client.phone || "-"}
              </Typography>
            </Box>

            {/* Company Name */}
            {client.companyName && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Icon name="projects" size={16} color={COLORS.SECONDARY} />
                <Typography sx={{ ...TYPOGRAPHY.BODY_STANDARD, color: COLORS.TEXT }}>
                  <strong>Company:</strong> {client.companyName}
                </Typography>
              </Box>
            )}

            {/* Address */}
            {(client.companyAddress || client.city || client.state) && (
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
                <Box sx={{ mt: 0.3 }}>
                  <Icon name="location" size={16} color={COLORS.SECONDARY} />
                </Box>
                <Typography sx={{ ...TYPOGRAPHY.BODY_STANDARD, color: COLORS.TEXT }}>
                  <strong>Address:</strong>{" "}
                  {[client.companyAddress, client.city, client.state]
                    .filter(Boolean)
                    .join(", ")}
                </Typography>
              </Box>
            )}

            {/* Joined */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
              <Icon name="calendar2" size={16} color={COLORS.MUTED_TEXT} />
              <Typography sx={{ ...TYPOGRAPHY.BODY_SMALL, color: COLORS.MUTED_TEXT }}>
                Joined on:{" "}
                {new Date(client.joinedAt || client.createdAt).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ClientDetailsPopup;
